import type {
  InjectionGuideSource,
  InjectionGuideVariant,
} from "@care-by-ella/contracts";

// TES-1361 — the register's lines, kept pure so they can be tested without
// rendering. The Swedish copy is proposed.

export function fmtDateTime(iso: string | null): string {
  if (!iso) return "–";
  return new Date(iso).toLocaleString("sv-SE", {
    timeZone: "Europe/Stockholm",
    dateStyle: "short",
    timeStyle: "short",
  });
}

export function fmtDate(iso: string | null): string {
  if (!iso) return "–";
  return new Date(iso).toLocaleDateString("sv-SE", {
    timeZone: "Europe/Stockholm",
  });
}

/** One line on what the latest check of a source saw. */
export function sourceStatus(s: InjectionGuideSource): string {
  if (!s.active) return "Kontrolleras inte (avstängd)";
  if (!s.lastCheckedAt) return "Inte kontrollerad ännu";
  const parts = [`Kontrollerad ${fmtDateTime(s.lastCheckedAt)}`];
  if (s.lastCheckError) {
    parts.push(`kunde inte läsas (${s.lastCheckError})`);
    if (s.lastReadAt) parts.push(`senast läst ${fmtDateTime(s.lastReadAt)}`);
  }
  if (s.observedVersion) parts.push(`version ${s.observedVersion}`);
  if (s.observedSignature) {
    parts.push(`signatur ${s.observedSignature.slice(0, 12)}`);
  }
  return parts.join(" · ");
}

/**
 * The recorded content version, and the article as it stands now when that
 * differs: a newer published version than the recorded one has not been
 * entered in the register.
 */
export function contentVersionText(v: InjectionGuideVariant): string {
  const recorded =
    v.contentVersion !== null
      ? `version ${v.contentVersion}`
      : "ej registrerad";
  if (!v.article) {
    return v.articleKey ? `${recorded} (artikeln saknas)` : recorded;
  }
  if (v.article.status !== "published") {
    return `${recorded} (artikeln är inte publicerad)`;
  }
  if (v.contentVersion !== v.article.version) {
    return `${recorded} · publicerad nu: version ${v.article.version}`;
  }
  return recorded;
}
